import { FC } from 'react';
import { MaterializationStatusState } from '../../api/gql/graphql';
import { Badge } from '@lithos';
import { BadgeColor } from '@lithos/Badge';

interface JobsStatusBadgeProps {
  status: MaterializationStatusState;
}

const JobStatusBadge: FC<JobsStatusBadgeProps> = ({ status }) => {
  const variantAndLabel: Record<MaterializationStatusState, { label: string; variant: BadgeColor }> = {
    [MaterializationStatusState.MaterializationStatusStateDrained]: {
      label: 'Drained',
      variant: 'gray',
    },
    [MaterializationStatusState.MaterializationStatusStateError]: {
      label: 'Error',
      variant: 'red',
    },
    [MaterializationStatusState.MaterializationStatusStateManuallyCancelled]: {
      label: 'Manually Cancelled',
      variant: 'yellow',
    },
    [MaterializationStatusState.MaterializationStatusStateManualCancellationRequested]: {
      label: 'Cancellation Requested',
      variant: 'yellow',
    },
    [MaterializationStatusState.MaterializationStatusStatePending]: {
      label: 'Pending',
      variant: 'blueMist',
    },
    [MaterializationStatusState.MaterializationStatusStateRunning]: {
      label: 'Running',
      variant: 'blue',
    },
    [MaterializationStatusState.MaterializationStatusStateScheduled]: {
      label: 'Scheduled',
      variant: 'blue',
    },
    [MaterializationStatusState.MaterializationStatusStateSuccess]: {
      label: 'Success',
      variant: 'green',
    },
    [MaterializationStatusState.MaterializationStatusStateUnspecified]: {
      label: 'Unspecified',
      variant: 'gray',
    },
  };

  return <Badge label={variantAndLabel[status].label} color={variantAndLabel[status].variant} size="s" />;
};

export default JobStatusBadge;
